import { Routes, Route, Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuthStore } from './store/auth.store';

// Layout
import MainLayout from './components/layout/MainLayout';

// Auth
import LoginPage from './features/auth/LoginPage';

// Dashboard
import DashboardPage from './features/dashboard/DashboardPage';

// Products
import ProductsPage from './features/products/ProductsPage';

// Inventory
import InventoryPage from './features/inventory/InventoryPage';

// Orders
import OrdersPage from './features/orders/OrdersPage';

// Tasks
import TasksPage from './features/tasks/TasksPage';

// Admin
import AdminPage from './features/admin/AdminPage';

// Finance
import FinancePage from './features/finance/FinancePage';
import FinancialHubPage from './features/financial-hub/FinancialHubPage';

// Strategy
import StrategyPage from './features/strategy/StrategyPage';

// Sales Planning
import SalesPlanningPageV3 from './features/sales-planning/SalesPlanningPageV3';

// BDO
import BdoPage from './features/bdo/BdoPage';

// Integrations
import IntegrationsPage from './features/integrations/IntegrationsPage';

// CRM
import CrmPage from './features/crm/CrmPage';
import { ContractorsList } from './features/crm/components/ContractorsList';
import { ContractorDetailsPage } from './features/crm/pages/ContractorDetailsPage';

// Profile
import UserProfilePage from './features/profile/UserProfilePage';

// Notifications
import NotificationsPage from './features/notifications/NotificationsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated } = useAuthStore();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}

function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <MainLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="inventory" element={<InventoryPage />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="tasks/*" element={<TasksPage />} />
                <Route path="finance" element={<FinancePage />} />
                <Route path="financial-hub" element={<FinancialHubPage />} />
                <Route path="strategy" element={<StrategyPage />} />
                <Route path="sales-planning" element={<SalesPlanningPageV3 />} />
                <Route path="bdo" element={<BdoPage />} />
                <Route path="integrations" element={<IntegrationsPage />} />
                <Route path="crm" element={<CrmPage />} />
                <Route path="b2b" element={<ContractorsList />} />
                <Route path="b2b/:id" element={<ContractorDetailsPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route path="profile/:id" element={<UserProfilePage />} />
                <Route path="admin/*" element={<AdminPage />} />

                {/* Legacy Redirects */}
                <Route path="crm/contractors/:id" element={<LegacyContractorRedirect />} />

                {/* 404 Fallback */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
        </Routes>
    );
}

// Redirect component for old notifications
function LegacyContractorRedirect() {
    const { id } = useParams<{ id: string }>();
    const [searchParams] = useSearchParams();
    return <Navigate to={`/b2b/${id}?${searchParams.toString()}`} replace />;
}

export default App;
